import { Helmet, HelmetProvider } from 'react-helmet-async';
import Navbar from '../components/navbar';
import React, {useState, useEffect} from 'react';
import HeroSection from '../components/HeroSection';
import TrustSection from '../components/TrustSection';
import Trust2Section from '../components/Trust2Section';
import HowItWorksSection from '../components/HowItWorksSection';
import Features from '../components/FeaturesSection';
import ReviewSection from '../components/ReviewsSection';
import FaqSection from '../components/FaqSection';
import Footer from '../components/Footer';
import MobileCta from '../components/MobileCta';
import ImSection from '../components/ImSection';
import data from '../data/content.json';
import { doc, getDoc } from "firebase/firestore";
import {db} from '../firebase'; // Adjust the import path as necessary


const PlantFinderLandingPage = (props) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      // const isDevelopment = process.env.NODE_ENV === 'development';

      const docRef = doc(db, "content", "content_landing_page_plant_finder_english");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setContent(JSON.parse(docSnap.data().value));
      } else {
        setContent(data); // or handle fallback
      }
    };
    fetchContent();
  }, []);

  return (
    !content ? (
      <div className="w-full h-screen flex items-center justify-center">
        <p className="text-gray-600">Loading content...</p>
      </div>
    ) :
    <HelmetProvider>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        {/* <link href="https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,100..900;1,9..144,100..900&display=swap" rel="stylesheet" /> */}
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&family=Roboto+Condensed:wght@400;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <div className="plant-finder">
        <Navbar content={content} />
        <HeroSection content={content} />
        <TrustSection content={content} />
        <HowItWorksSection content={content} />
        <Trust2Section content={content} />
        <Features content={content} />
        <ImSection content={content} />
        <ReviewSection content={content} />
        <FaqSection content={content} />
        <Footer content={content} />
        <MobileCta content={content} />
      </div>
    </HelmetProvider>
  );

}

export default PlantFinderLandingPage;
